import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TodayLightModule } from 'projects/workplace-light/src/app/today-light/today-light.component';
import { FindInformationModule } from '@app/views/find-information/find-information.component';
import { TodayModule } from '@app/views/today/today.component';
import { MyBoardModule } from '@app/views/my-board/my-board.component';
import { CollaborationModule } from '@app/views/collaboration/collaboration.component';
import { FindInformationLightModule } from '@app/views/find-information-light/find-information-light.component';
import { Demo_CUSTOM_ROUTE_CONFIG } from './custom-route-config';

@NgModule({
  imports: [
    TodayModule,
    TodayLightModule,
    MyBoardModule,
    CollaborationModule,
    FindInformationModule,
    FindInformationLightModule,
    RouterModule.forRoot(Demo_CUSTOM_ROUTE_CONFIG, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
})
  ]
})
export class WorkplaceDemoAppRoutingModule { }
